import { CSAT_RATINGS } from 'shared/constants/messages';
import { csatRatingNames } from './csatRatingNames';

export const buildRatingsList = t => {
  const names = csatRatingNames(t);
  return CSAT_RATINGS.map(rating => ({
    id: rating.value,
    name: names[rating.value],
    type: 'ratings',
  }));
};
